export enum AccountingTransactionType {
  GENERAL_JOURNAL = "GENERAL_JOURNAL",
  CASH_IN_OUT = "CASH_IN_OUT",
}
